var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUrgent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 11.2497C3 6.69382 6.69318 3 11.2503 3C15.8062 3 19.5 6.69382 19.5 11.2497C19.5 15.8062 15.8062 19.5 11.2503 19.5C6.69318 19.5 3 15.8062 3 11.2497ZM11.2493 6.4375C10.7183 6.4375 10.2875 6.85749 10.2875 7.37729C10.2875 12.307 11.2493 13.101 11.2493 13.101C11.2493 13.101 12.2125 12.307 12.2125 7.37729C12.2125 6.85749 11.781 6.4375 11.2493 6.4375ZM11.2493 14.1375C10.7183 14.1375 10.2875 14.5685 10.2875 15.1003C10.2875 15.6315 10.7183 16.0625 11.2493 16.0625C11.781 16.0625 12.2125 15.6315 12.2125 15.1003C12.2125 14.5685 11.781 14.1375 11.2493 14.1375Z",
    fill: "#AD9306"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUrgent);
export default __webpack_public_path__ + "static/media/icon_urgent.91b77504a0108aeb3af687da86bb41c2.svg";
export { ForwardRef as ReactComponent };